import { useContext, useEffect } from "react";
import { STATEMENT_KEYS } from "../data/statements";
import { Link } from "react-router";
import { LocaleContext } from "../app";
import Markdown from "react-markdown";
import { Footer } from "./footer";
import { Tellit } from "./tellit";

export function ChooseTheme() {
  const { translate } = useContext(LocaleContext);

  useEffect(() => {
    const interval = setInterval(() => {
      if (window.fathom) {
        window.fathom.trackPageview({ url: window.location.toString() });
        clearInterval(interval);
      }
    }, 250);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Tellit
        name="main"
        url="https://tell-it-production-public.s3.eu-central-1.amazonaws.com/e77351fcfbce3bb239dd7183/story.json"
      />

      <main className="app__container">
        <div className="card">
          <div className="card__intro">
            <h2 className="card__title">{translate("intro.title")}</h2>
            <p className="card__description">
              {translate("intro.description")}
            </p>
          </div>

          {STATEMENT_KEYS.map((key, index) => (
            <Link to={key} key={key} className="link-card">
              {index + 1}. {translate(["statements", key, "shortName"])}
            </Link>
          ))}

          <button
            className="link"
            command="show-modal"
            commandfor="fullTextDialog"
            onClick={() => {
              if (window.fathom) {
                window.fathom.trackEvent("pop-up KB opened");
              }
            }}
          >
            {translate("intro.full_text.trigger")}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="link__icon"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M11.6667 15L16.6667 10L11.6667 5L10.5 6.20833L13.4583 9.16667H3.33334V10.8333H13.4583L10.5 13.7917L11.6667 15Z"
                fill="currentcolor"
              />
            </svg>
          </button>

          <Footer />
        </div>
      </main>

      <dialog
        id="fullTextDialog"
        aria-labelledby="fullTextDialogTitle"
        closedby="any"
        className="dialog"
      >
        <div className="dialog__content">
          <div className="dialog__header">
            <h2 id="fullTextDialogTitle" className="dialog__title">
              {translate("intro.full_text.title")}
            </h2>
            <button
              type="button"
              className="dialog__close"
              command="close"
              commandfor="fullTextDialog"
            >
              <span className="sr-only">
                {translate("intro.full_text.close")}
              </span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentcolor"
                className="dialog__close-icon"
              >
                <path d="M5.33335 15.8334L4.16669 14.6667L8.83335 10L4.16669 5.33335L5.33335 4.16669L10 8.83335L14.6667 4.16669L15.8334 5.33335L11.1667 10L15.8334 14.6667L14.6667 15.8334L10 11.1667L5.33335 15.8334Z" />
              </svg>
            </button>
          </div>
          <div className="dialog__body">
            <Markdown>{translate("intro.full_text.body")}</Markdown>
          </div>
          <button
            className="dialog__close"
            type="button"
            command="close"
            commandfor="fullTextDialog"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentcolor"
              className="dialog__close-icon"
            >
              <path d="M5.33335 15.8334L4.16669 14.6667L8.83335 10L4.16669 5.33335L5.33335 4.16669L10 8.83335L14.6667 4.16669L15.8334 5.33335L11.1667 10L15.8334 14.6667L14.6667 15.8334L10 11.1667L5.33335 15.8334Z" />
            </svg>
            {translate("intro.full_text.close")}
          </button>
        </div>
      </dialog>
    </>
  );
}
